module.exports = __webpack_public_path__ + "img/home_group.e8ab392d.png";